import { useNavigate } from "react-router-dom";

const WaitingRoom = () => {
  const navigate = useNavigate();
  const onSubmitPersonalTest = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    //and navigate to PersonalTest
    navigate("/fun_learning/personaltest");
  };
  return (
    <div className="h-lvh dark:bg-gray-700 bg-gray-200 pt-12 pb-5 ">
      <div className="dark:text-slate-200 font-bold text-slate-800 text-2xl text-center max-w-sm mx-auto mt-5 mb-3">
        Let's get started!
      </div>
      <form
        onSubmit={onSubmitPersonalTest}
        className="max-w-md mx-auto mt-10 p-6 bg-white dark:bg-gray-800 border dark:border-slate-500 rounded-lg shadow-lg dark:shadow-none"
      >
        <div className="flex justify-between">
          {" "}
          <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-slate-200">
            code:1278
          </h2>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            Room Name: 야 한판 뜨자!
          </label>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
            personal
          </span>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            참가자 목록
          </label>

          <table className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  my id
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  참여 여부
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src="https://randomuser.me/api/portraits/men/1.jpg"
                        alt=""
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        kim04091
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        방장
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    참여
                  </span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src="https://randomuser.me/api/portraits/men/1.jpg"
                        alt=""
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        chrisYoo
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        user
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    참여
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mb-4">
          <div className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            단어선택
          </div>
          <div className="flex gap-3">
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="단어">단어</option>
              <option value="단어1">단어1</option>
              <option value="단어2">단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="영어단어">영어단어</option>
              <option value="영어단어1">영어단어1</option>
              <option value="영어단어2">영어단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="고등단어">고등단어</option>
              <option value="고등단어1">고등단어1</option>
              <option value="고등단어2">고등단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="01지학사">01지학사</option>
              <option value="02지학사">02지학사</option>
              <option value="03지학사">03지학사</option>
            </select>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            학습목록
          </label>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 01 (20)
          </span>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 02 (20)
          </span>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 02 (20)
          </span>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            문제수
          </label>
          <input
            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 dark:text-white leading-tight focus:outline-none focus:shadow-outline dark:border-gray-600 dark:bg-slate-500"
            type="text"
            placeholder="Number of problems"
          />
        </div>

        <div className="text-5xl mt-10 mb-10">🏆</div>
        <button
          className="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Get started
        </button>
      </form>

      {/* 팀전일시 */}

      <div className="dark:text-slate-200 font-bold text-slate-800 text-2xl text-center max-w-sm mx-auto mt-5 mb-3">
        팀전일시 디자인만 해 놓았습니다.
      </div>
      <form className="max-w-md mx-auto mt-10 p-6 bg-white dark:bg-gray-800 border dark:border-slate-500 rounded-lg shadow-lg dark:shadow-none">
        <div className="flex justify-between">
          {" "}
          <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-slate-200">
            code:1278
          </h2>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            Room Name: 야 한판 뜨자!
          </label>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-700 dark:text-blue-200">
            team
          </span>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            참가자 목록
          </label>

          <table className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  my id
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  팀
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  참여 여부
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src="https://randomuser.me/api/portraits/men/1.jpg"
                        alt=""
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        kim04091
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        방장
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    A
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    참여
                  </span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src="https://randomuser.me/api/portraits/men/1.jpg"
                        alt=""
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        chrisYoo
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        user
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    B
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                    참여
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mb-4">
          <div className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            단어선택
          </div>
          <div className="flex gap-3">
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="단어">단어</option>
              <option value="단어1">단어1</option>
              <option value="단어2">단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="영어단어">영어단어</option>
              <option value="영어단어1">영어단어1</option>
              <option value="영어단어2">영어단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="고등단어">고등단어</option>
              <option value="고등단어1">고등단어1</option>
              <option value="고등단어2">고등단어2</option>
            </select>
            <select className="block w-sm text-sm font-medium transition duration-75 border border-slate-300 rounded-lg shadow-sm h-9 focus:border-blue-600 focus:ring-1 focus:ring-inset focus:ring-blue-600 bg-none dark:bg-slate-500 dark:text-slate-200">
              <option value="01지학사">01지학사</option>
              <option value="02지학사">02지학사</option>
              <option value="03지학사">03지학사</option>
            </select>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            학습목록
          </label>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 01 (20)
          </span>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 02 (20)
          </span>
          <span className="px-2 mr-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200">
            Pelt_Junior3급 - 02 (20)
          </span>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            문제수
          </label>
          <input
            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 dark:text-white leading-tight focus:outline-none focus:shadow-outline dark:border-gray-600 dark:bg-slate-500"
            type="text"
            placeholder="Number of problems"
          />
        </div>

        <div className="text-5xl mt-10 mb-10">🏆</div>
        <button
          className="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Get started
        </button>
      </form>
    </div>
  );
};

export default WaitingRoom;
